module.exports = __webpack_public_path__ + "img/Banner.c560cb9e.png";